import { z } from 'zod';
export const changeAuthorTypeSchema = z.enum({
    // Customer of an offer request, the user who requested the offer.
    Customer: 'customer',
    // Anything a partner changes through a link they were sent, such as a report or a sharable page.
    Partner: 'partner',
    // Jobs and system automations.
    System: 'system',
    // Users of the operations tool.
    Admin: 'admin',
    PartnerCockpit: 'partnerCockpit',
});
export const ChangeAuthorType = changeAuthorTypeSchema.enum;
const namedChangeAuthorTypeSchema = z.enum([
    ChangeAuthorType.Customer,
    ChangeAuthorType.Partner,
    ChangeAuthorType.Admin,
    ChangeAuthorType.PartnerCockpit,
]);
export const changeAuthorSchema = z.union([
    z.object({ type: z.literal(ChangeAuthorType.System) }),
    z.object({
        type: namedChangeAuthorTypeSchema,
        displayName: z.string(),
        avatar: z.string().optional(),
    }),
]);
